import * as Yup from "yup";
import { CalculatorField, LegalForm } from "../types";

export const CALCULATOR_VALIDATION_SCHEMA = Yup.object().shape({
  [CalculatorField.legalForm]: Yup.string().required(),
  [CalculatorField.taxationSystem]: Yup.string().required(),

  [CalculatorField.singleTaxGroup]: Yup.string().when(
    [CalculatorField.legalForm, CalculatorField.taxationSystem],
    {
      is: (legalForm: string, taxationSystem: string) =>
        (legalForm === LegalForm.indEnt && taxationSystem === "загальна") ||
        (legalForm === LegalForm.legEnt && taxationSystem === "загальна"),
      then: () => Yup.string().optional().nullable(),
      otherwise: () => Yup.string().required(),
    }
  ),

  [CalculatorField.vatPayer]: Yup.string().when(
    [CalculatorField.legalForm, CalculatorField.taxationSystem],
    {
      is: (legalForm: string, taxationSystem: string) =>
        legalForm === LegalForm.legEnt && taxationSystem === "загальна",
      then: () => Yup.string().optional().nullable(),
      otherwise: () =>
        Yup.string().when(CalculatorField.legalForm, {
          is: LegalForm.legEnt,
          then: () => Yup.string().required(),
          otherwise: () => Yup.string().optional().nullable(),
        }),
    }
  ),

  [CalculatorField.exciseTaxPayer]: Yup.string().when(
    [CalculatorField.legalForm, CalculatorField.taxationSystem],
    {
      is: (legalForm: string, taxationSystem: string) =>
        legalForm === LegalForm.legEnt && taxationSystem === "загальна",
      then: () => Yup.string().optional().nullable(),
      otherwise: () =>
        Yup.string().when(CalculatorField.legalForm, {
          is: LegalForm.legEnt,
          then: () => Yup.string().required(),
          otherwise: () => Yup.string().optional().nullable(),
        }),
    }
  ),

  [CalculatorField.hiredWorkers]: Yup.boolean().when(
    CalculatorField.legalForm,
    {
      is: LegalForm.legEnt,
      then: () => Yup.boolean().optional().nullable(),
      otherwise: () => Yup.boolean().required(),
    }
  ),

  [CalculatorField.workersCount]: Yup.number().when(
    CalculatorField.hiredWorkers,
    {
      is: true,
      then: () => Yup.number().integer().min(1).max(10000).required(),
      otherwise: () => Yup.number().nullable(),
    }
  ),
});
